(function() {
  'use strict';
  angular.module('app.careerDecisionProfileClient').config(state);

  state.$inject = ['$stateProvider', 'RouteHelpersProvider'];

  function state($stateProvider, helper) {
    $stateProvider

      .state('app.careerdecisionprofileclient', {
        url: '/cdp/clients',
        title: 'Career Decision Profile Clients',
        templateUrl: helper.basepath(
          'careerDecisionProfileClient/views/careerDecisionProfileClient.html'
        ),
        controller: 'CDPClientController',
        controllerAs: 'vm',
        params: {
          parameter: null
        },
        resolve: helper.resolveFor(
          'modernizr',
          'icons',
          'datatables',
          'ui.select',
          'ngDialog',
          'ngWig'
        ),
        secured: true
      })
      .state('app.careerdecisionprofileclientdetails', {
        url: '/cdp/clients/:clientId',
        title: 'Client Details',
        templateUrl: helper.basepath(
          'careerDecisionProfileClient/views/careerDecisionProfileClientDetails.html'
        ),
        controller: 'CDPClientDetailsController',
        controllerAs: 'vm',
        resolve: helper.resolveFor('modernizr', 'icons', 'datatables'),
        secured: true
      });
  }
})();
